import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class CQMSTileConstants {
    title = "CQMS Dashboard";

    //Checklist Configuration
    checklistConfigTitle = "Checklist Configuration";
    checklistConfigUrl = "cqms-dashboard/checklist-configuration";

    //Facility Configuration
    facilityConfigTitle = "Facility Configuration";
    facilityConfigUrl = "cqms-dashboard/facility-configuration";

    //User Settings
    userSettingsTitle = "User Settings";
    userSettingsUrl = "cqms-dashboard/users";

    //Tableau Dash
    tableauDashTitle = "Tableau Dashboard Link";
    tableauDashUrl = "https://www.claytonbi.com/#/views/CQMSOperationalDashboard/InspectionOverview";

    //Defect History
    defectHistoryTitle = "Defect History";
    defectHistoryUrl = "cqms-dashboard/defect-history";

    //general
    comingSoonTooltip = "Feature Coming Soon!";
}